/**
 * ISO Standard Selector Component
 * Dropdown to select ISO standard with role-based filtering
 * - Super Admin: All 26 ISO standards
 * - Certification Bodies: Only purchased ISO standards
 * - Clients: Only assigned ISO standards
 */
import React, { useState, useEffect } from 'react';
import { isoStandardsService } from '../../api/isoStandardsService';

export const ISOStandardSelector = ({ value, onChange, disabled = false }) => {
  const [standards, setStandards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStandards = async () => {
      try {
        setLoading(true);
        const response = await isoStandardsService.getPurchased();
        if (response.data && Array.isArray(response.data)) {
          setStandards(response.data);
        }
      } catch (error) {
        console.error('Failed to fetch ISO standards:', error);
        setStandards([]);
      } finally {
        setLoading(false);
      }
    };

    fetchStandards();
  }, []);

  return (
    <div className="space-y-2">
      <label htmlFor="iso-standard" className="block text-sm font-medium text-gray-700">
        ISO Standard <span className="text-red-500">*</span>
      </label>

      <select
        id="iso-standard"
        value={value || ''}
        onChange={(e) => onChange(Number(e.target.value))}
        disabled={disabled || loading}
        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
        required
      >
        <option value="">Select ISO Standard...</option>
        {standards.map((standard) => (
          <option key={standard.id} value={standard.id}>
            {standard.code}{standard.version ? `:${standard.version}` : ''} - {standard.name}
          </option>
        ))}
      </select>

      {loading && <p className="text-xs text-gray-500">Loading standards...</p>}
    </div>
  );
};

export default ISOStandardSelector;
